const MIN_WIDTH = 260;
const MAX_WIDTH = 800;
const SIDE_MARGIN = 12;
const SLACK = 24;
const CLOSE_SPACE = 34;
const DEFAULT_FONT = "14px";
const DEFAULT_PADDING = "12px";

let measureEl = null;

const ensureMeasureEl = () => {
  if (measureEl) return measureEl;
  const el = document.createElement("span");
  el.style.position = "absolute";
  el.style.visibility = "hidden";
  el.style.pointerEvents = "none";
  el.style.left = "-9999px";
  el.style.top = "-9999px";
  el.style.whiteSpace = "nowrap";
  el.style.boxSizing = "border-box";
  document.body.appendChild(el);
  measureEl = el;
  return measureEl;
};

export const measureNoticeWidth = (text, options = {}) => {
  const { font = DEFAULT_FONT, padding = DEFAULT_PADDING } = options;
  if (!text) return MIN_WIDTH;

  const el = ensureMeasureEl();
  el.style.fontSize = font;
  el.style.padding = padding;
  el.textContent = String(text);

  const measured = Math.ceil(el.offsetWidth);
  const raw = measured + SLACK + CLOSE_SPACE;
  return Math.max(MIN_WIDTH, raw);
};

export const getViewportCap = () => {
  const vw = typeof window !== "undefined" ? window.innerWidth : MAX_WIDTH;
  const safeVw = Math.max(0, vw - SIDE_MARGIN * 2);
  return Math.max(MIN_WIDTH, Math.min(MAX_WIDTH, safeVw));
};
